module.exports = __webpack_public_path__ + "img/naturwissenschaften_technik.01e0a83.svg";